import { render } from "./StoreChooseTabbar.vue?vue&type=template&id=6577c41c&scoped=true"
import script from "./StoreChooseTabbar.vue?vue&type=script&lang=js"
export * from "./StoreChooseTabbar.vue?vue&type=script&lang=js"

import "./StoreChooseTabbar.vue?vue&type=style&index=0&id=6577c41c&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6577c41c"]])

export default __exports__